import { ActionReducer, MetaReducer } from '@ngrx/store';
import { getFromStorage, saveToStorage } from '../helpers/storageUtils';
 
export function sessionStorageMetaReducer(reducer: ActionReducer<any>): ActionReducer<any> {
    return function (state, action) {
        // Al inicializar, si el estado es undefined, intenta cargar el estado desde sessionStorage
        if (state === undefined) {
            const storedState = getFromStorage('state', 'session');
            if (storedState) {
                return storedState;
            }
        }
        // Procesa la acción y obtiene el siguiente estado
        const nextState = reducer(state, action);
        // Guarda el siguiente estado en sessionStorage
        saveToStorage('state', JSON.stringify(nextState), 'session');
        return nextState;
    };
}
 
export const metaReducers: MetaReducer<any>[] = [sessionStorageMetaReducer];